import { render } from "./LoanFundsRequestListing.vue?vue&type=template&id=52a8fab9&ts=true"
import script from "./LoanFundsRequestListing.vue?vue&type=script&lang=ts"
export * from "./LoanFundsRequestListing.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__